import React from "react";
import styled from "styled-components";
import Navigation from "./Navigation";
import WaveCanvas from "./WaveCanvas";
import OrbCanvas from "./OrbCanvas";

const HeaderContainer = styled.header`
  height: 450px;
  background: #0a0e16;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* ナビ(約60px)を除いた見える範囲の中央にテキストが来るように */
  padding-top: 60px;

  @media (max-width: 768px) {
    height: 320px;
  }
  color: #fff;
  text-align: center;
  position: relative;
  overflow: hidden;
  /* z-index:-1のキャンバスが背景の上に乗るようスタッキングコンテキストを作る */
  isolation: isolate;
`;

const HeaderContent = styled.div`
  max-width: 800px;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
  text-shadow:
    0 2px 20px rgba(10, 14, 22, 0.95),
    0 0 3px rgba(10, 14, 22, 0.8);
`;

const Title = styled.h1`
  font-size: 3.5rem;
  margin-bottom: 1rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.5rem;

  @media (max-width: 768px) {
    font-size: 1.05rem;
  }
`;

const Button = styled.button`
  margin-top: 2rem;
  padding: 0.8rem 2rem;
  background-color: #0099cc;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #007aa3;
  }
`;

const HeroOrb = styled(OrbCanvas)`
  /* ビューポート基準にしてスクロールと一緒に降りてくるように */
  position: fixed;
  left: -40px;
  top: 50px;
  width: 420px;
  height: 420px;
  opacity: 0.75;

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
    left: -30px;
    top: 80px;
    opacity: 0.55;
  }
`;

const Header = ({ title, subtitle, showButton = true }) => {
  return (
    <>
      {/* overflow:hidden/isolationの内側だとSPメニューが切れるためヒーローの外に置く */}
      <Navigation />
      <HeaderContainer>
        <WaveCanvas scale={0.7} speed={0.5} />
        <HeroOrb
          type="logo"
          speed={0.006}
          tilt={0.3}
          zoom={1.35}
          size={520}
        />
        <HeaderContent>
          <Title data-aos="fade-down" data-aos-delay="100">
            {title}
          </Title>
          <Subtitle data-aos="fade-up" data-aos-delay="300">
            {subtitle}
          </Subtitle>
          {showButton && (
            <Button data-aos="zoom-in" data-aos-delay="500">
              お問い合わせ
            </Button>
          )}
        </HeaderContent>
      </HeaderContainer>
    </>
  );
};

export default Header;
